import React from 'react';
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Our Toolbox for Creating Custom Software Excellence</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
            Utilizing a dynamic array of progressive technologies, we design customized software solutions that redefine excellence in the digital world.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>HTML 5</li>
                <li>CSS</li>
                <li>Java Script</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="BackEnd">
              <ul>
                <li>.Net</li>
                <li>Java</li>
                <li>Python</li>
                <li>Php</li>
                <li>Node JS</li>
                <li>GO</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Technologies">
              <ul>
                <li>REST</li>
                <li>JavaEE</li>
                <li>AR/VR</li>
                <li>Unity 3D</li>
                <li>Spring</li>
                <li>GraphQL</li>
                <li>JPA/Hibernate</li>
                <li>QT.NET</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Platforms">
              <ul>
                <li>Angular</li>
                <li>React Native</li>
                <li> Vue.JS</li>
                <li>ember</li>
                <li>Meteor</li>
                <li>NEXT.JS</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Google Assistant</li>
                <li>Google VR</li>
                <li>Machine Learning(ML Kit)</li>
                <li>Firebase</li>
                <li>Google Cloud</li>
                <li>Google Analytics</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
